export const STOCK_IMAGE_PATH_SEGMENT = '/stock-photography/';
